import React from 'react';
import { motion } from 'framer-motion';
import { UtensilsCrossed, Coffee, Beer, ShoppingBag, Building2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const BAKERY_IMG = '/images/mockup-local.png';
const typeIcons = [UtensilsCrossed, Coffee, Beer, ShoppingBag, Building2];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: 'easeOut', delay },
});

export default function BusinessTypes() {
  const { t } = useLanguage();
  const bt = t.businessTypes;

  return (
    <section className="py-14 md:py-20 bg-[#1A222B]" data-testid="business-types-section">
      <div className="section-container">
        <motion.div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16" {...fadeUp()}>
          <div>
            <div className="divider-gold" />
            <h2 className="heading-lg mb-5">{bt.title}</h2>
            <p className="text-[#8A9099] text-base leading-relaxed">{bt.body}</p>
          </div>
          <div className="relative group overflow-hidden rounded-2xl">
            <img src={BAKERY_IMG} alt="Negocio con MatchPool.live"
              className="w-full h-72 object-cover object-top transition-transform duration-700 group-hover:scale-105"
              data-testid="business-types-img" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A222B]/80 via-transparent to-transparent" />
          </div>
        </motion.div>

        {/* Business type cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {bt.types.map((biz, i) => {
            const Icon = typeIcons[i];
            return (
              <motion.div key={i} className="card-dark p-6 text-center" {...fadeUp(0.1 + i * 0.08)}
                data-testid={`business-type-${i}`}>
                <div className="w-12 h-12 rounded-full bg-[#0F6B49]/20 flex items-center justify-center mx-auto mb-4
                  border border-[#0F6B49]/30">
                  <Icon size={20} className="text-[#D5A63B]" />
                </div>
                <h3 className="font-exo font-bold italic text-[#F3F1EB] text-base mb-2">{biz.type}</h3>
                <p className="text-[#8A9099] text-xs leading-relaxed">{biz.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
